import {createContext} from 'react';

const SymbolContextMobile = createContext(null);

export default SymbolContextMobile;
